import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=21f2a958&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=ts&"
export * from "./Logo.vue?vue&type=script&lang=ts&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=21f2a958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f2a958",
  null
  
)

export default component.exports